import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { TipoUsuario } from 'src/app/shared/enums/tipoUsuario';

@Component({
  selector: 'app-vigencias-listados-index',
  templateUrl: './vigencias-listados-index.component.html',
  styleUrls: ['./vigencias-listados-index.component.css']
})
export class VigenciasListadosIndexComponent implements OnInit {

  TipoUsuario = TipoUsuario;

  constructor(private router:Router, public authService: AuthService) { }

  ngOnInit() {
  }

}
